/* eslint-disable */
// adapted from the second part of the snippet provided here: https://websdk.appsflyer.com?st=banners
function script(e) {
  var t = {}
  function __webpack_require__(n) {
    if (t[n]) return t[n].exports
    var o = (t[n] = { i: n, l: !1, exports: {} })
    return (
      e[n].call(o.exports, o, o.exports, __webpack_require__),
      (o.l = !0),
      o.exports
    )
  }
  ;(__webpack_require__.m = e),
    (__webpack_require__.c = t),
    (__webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) ||
        Object.defineProperty(e, t, { enumerable: !0, get: n })
    }),
    (__webpack_require__.r = function (e) {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(e, '__esModule', { value: !0 })
    }),
    (__webpack_require__.t = function (e, t) {
      if ((1 & t && (e = __webpack_require__(e)), 8 & t)) return e
      if (4 & t && 'object' == typeof e && e && e.__esModule) return e
      var n = Object.create(null)
      if (
        (__webpack_require__.r(n),
        Object.defineProperty(n, 'default', { enumerable: !0, value: e }),
        2 & t && 'string' != typeof e)
      )
        for (var o in e)
          __webpack_require__.d(
            n,
            o,
            function (t) {
              return e[t]
            }.bind(null, o),
          )
      return n
    }),
    (__webpack_require__.n = function (e) {
      var t =
        e && e.__esModule
          ? function getDefault() {
              return e.default
            }
          : function getModuleExports() {
              return e
            }
      return __webpack_require__.d(t, 'a', t), t
    }),
    (__webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t)
    }),
    (__webpack_require__.p = ''),
    __webpack_require__((__webpack_require__.s = 0))
}

const e = [
  function (e, t, n) {
    'use strict'
    n(1),
      n(2),
      (function () {
        if ('loading' !== document.readyState)
          return setTimeout.bind(null, init, 0)()
        function init() {
          var e
          window.AF_SDK = window.AF_SDK || {
            CONST: { AF_SESSION: 'AF_SESSION' },
            utils: n(3),
            xhr: n(9),
            initPluginsConfig:
              ((e = window.AF.id),
              'string' == typeof e ? { pba: { webAppId: e } } : e),
            BASE: sdkBase(),
            PLUGINS: window.AF.plugins || {},
          }
          var t,
            o,
            i = Object.keys(window.AF_SDK.PLUGINS)
          ;(window.AF_SDK.Q =
            window.AF && window.AF.q ? window.AF.q.slice(0) : []),
            (window.AF =
              ((t = window.AF_SDK.utils.fingerPrint()),
              (o = (function getSdkVersion() {
                for (var e = 0, t = {}, n = i.length; e < n; e++)
                  window.AF_SDK.PLUGINS[i[e]].VERSION &&
                    (t[i[e]] = window.AF_SDK.PLUGINS[i[e]].VERSION)
                return Object.assign({ BASE: '0.0.44' }, t)
              })()),
              function (e, n, i) {
                if (e && n) {
                  i =
                    arguments.length < 3 ||
                    !arguments[2] ||
                    !window.AF_SDK.utils.isObject(arguments[2])
                      ? window.AF_SDK.utils.createArgObject(arguments[2])
                      : arguments[2]
                  var r = window.AF_SDK.BASE.fetchFunc(e, n)
                  if (r) {
                    var a = window.AF_SDK.utils.getUrlParamsObject({
                        search: window.location.search,
                      }),
                      s = window.top.document.referrer || '',
                      c = Number(Date.now())
                    return r(
                      Object.assign(
                        {},
                        { data: i },
                        {
                          meta: Object.assign({}, t, {
                            version: o,
                            query: a,
                            referrer: s,
                            timestamp: c,
                          }),
                        },
                      ),
                    )
                  }
                }
              })),
            (function initialLoad() {
              for (var e = 0, t = i.length; e < t; e++)
                window.AF(i[e].toLowerCase(), 'load', { eventType: 'LOAD' })
            })(),
            window.AF_SDK.Q.length && window.AF_SDK.BASE.emptyQ(window.AF_SDK.Q)
        }
        function sdkBase() {
          function returnLogger(e) {
            return window.AF_SDK.utils.logger(e), !1
          }
          return {
            fetchFunc: function (e, t) {
              if (!window.AF_SDK)
                return returnLogger('AF_SDK global is not available on window')
              var n = e.toUpperCase()
              return window.AF_SDK.PLUGINS[n]
                ? (window.AF_SDK.PLUGINS[n] && window.AF_SDK.PLUGINS[n][t]) ||
                    window.AF_SDK.BASE[t] ||
                    returnLogger(
                      t +
                        ' does not exist in our SDK, please check the documentation',
                    )
                : returnLogger(
                    n +
                      ' is missing in AF_SDK, please add this SDK to the snippet',
                  )
            },
            emptyQ: function (e, t) {
              if (e.length)
                for (var n = 0; n < e.length; )
                  e[n].length < 3 ||
                  (window.AF_SDK.PLUGINS[e[n][1].toUpperCase()].emptyQ && !t)
                    ? n++
                    : e[n].length < 3 && t && e[n][1] !== t
                    ? n++
                    : ((e[n][3] = window.AF_SDK.utils.isObject(e[n][3])
                        ? e[n][3]
                        : window.AF_SDK.utils.createArgObject(e[n][3])),
                      window.AF(
                        e[n][1],
                        e[n][2],
                        e[n][3]
                          ? Object.assign(e[n][3], {
                              qTimestamp: Number(e[n][0]),
                            })
                          : { qTimestamp: Number(e[n][0]) },
                      ),
                      e.splice(n, 1))
            },
          }
        }
        window.addEventListener
          ? window.addEventListener(
              'DOMContentLoaded',
              setTimeout.bind(null, init, 0),
              !1,
            )
          : window.attachEvent
          ? window.attachEvent(
              'onDOMContentLoaded',
              setTimeout.bind(null, init, 0),
            )
          : (window.onload = init)
      })(window, document)
  },
  function (e, t, n) {
    'use strict'
    e.exports = void (
      Object.keys ||
      (Object.keys = function (e) {
        if (e !== Object(e))
          throw new TypeError('Object.keys called on a non-object')
        var t,
          n = []
        for (t in e) Object.prototype.hasOwnProperty.call(e, t) && n.push(t)
        return n
      })
    )
  },
  function (e, t, n) {
    'use strict'
    e.exports = void (
      Object.assign ||
      Object.defineProperty(Object, 'assign', {
        enumerable: !1,
        configurable: !0,
        writable: !0,
        value: function (e) {
          if (null == e)
            throw new TypeError('Cannot convert first argument to object')
          for (var t = Object(e), n = 1; n < arguments.length; n++) {
            var o = arguments[n]
            if (null != o) {
              o = Object(o)
              for (
                var i = Object.keys(Object(o)), r = 0, a = i.length;
                r < a;
                r++
              ) {
                var s = i[r],
                  c = Object.getOwnPropertyDescriptor(o, s)
                void 0 !== c && c.enumerable && (t[s] = o[s])
              }
            }
          }
          return t
        },
      })
    )
  },
  function (e, t, n) {
    'use strict'
    e.exports = (function () {
      var e = !!getUrlParamsObject({ key: 'af-sdk-dev' })
      function getUrlParamsObject(e) {
        if (
          (((e =
            arguments.length <= 0 || !arguments[0]
              ? { search: null }
              : arguments[0]).search = e.hasOwnProperty('search')
            ? e.search
            : location.search),
          (e.key = e.hasOwnProperty('key') ? e.key : null),
          (e.params = {}),
          !e.search.length)
        )
          return e.params
        for (
          var t = ('?' === e.search[0] ? e.search.substr(1) : e.search).split(
              '&',
            ),
            n = 0,
            o = t.length;
          n < o;
          n++
        )
          if (-1 !== t[n].indexOf('=')) {
            var i = t[n].split('=')
            if (
              (i[0].length &&
                (e.params[decodeURIComponent(i[0])] =
                  decodeURIComponent(i[1]) || null),
              e.key && decodeURIComponent(i[0]) === e.key)
            )
              return decodeURIComponent(i[1]) || null
          }
        return e.params
      }
      return {
        logger: function logger(e, t) {},
        getUrlParamsObject: getUrlParamsObject,
        env: function env() {
          return e
        },
        isJson: function isJson(e) {
          if (!e) return !1
          var t = [e.substr(0, 1), e.substr(-1)]
          return !(
            ('{' !== t[0] && '[' !== t[0]) ||
            ('}' !== t[1] && ']' !== t[1])
          )
        },
        isObject: function isObject(e) {
          return '[object Object]' === Object.prototype.toString.call(e)
        },
        isArray: function isArray(e) {
          return '[object Array]' === Object.prototype.toString.call(e)
        },
        tcJSON: function tcJSON(e, t) {
          try {
            return JSON[t](e)
          } catch (t) {
            return e
          }
        },
        dateUtil: function dateUtil() {
          return (
            (Date.prototype.addHours = function (e) {
              return this.setHours(this.getHours() + e), this
            }),
            (Date.prototype.addYears = function (e) {
              return this.setYear(this.getFullYear() + e), this
            }),
            new Date()
          )
        },
        createArgObject: function createArgObject(e) {
          return { arg: e }
        },
        fingerPrint: n(4),
        storage: n(6),
        session: n(7),
        cookie: n(8),
      }
    })()
  },
  function (e, t, n) {
    'use strict'
    n(5)
    e.exports = function () {
      function setResponse(e) {
        return 'NOT_SUPPORTED' === e ? e : e ? 'ENABLED' : 'DISABLED'
      }
      return {
        userAgent: (function userAgent() {
          return navigator.userAgent || ''
        })(),
        webDriver: (function webDriver() {
          return setResponse(navigator.webdriver || 'NOT_SUPPORTED')
        })(),
        languageKey: (function languageKey() {
          return (
            navigator.language ||
            navigator.userLanguage ||
            navigator.browserLanguage ||
            navigator.systemLanguage ||
            ''
          )
        })(),
        colorDepthKey: (function colorDepthKey() {
          return (window.screen && window.screen.colorDepth) || -1
        })(),
        cookieEnabled: (function cookieEnabled() {
          return navigator.cookieEnabled || !1
        })(),
        deviceMemoryKey: (function deviceMemoryKey() {
          return navigator.deviceMemory || -1
        })(),
        pixelRatioKey: (function pixelRatioKey() {
          return window.devicePixelRatio || -1
        })(),
        screenResolutionWidth: (function screenResolutionWidth() {
          return (window.screen && window.screen.width) || -1
        })(),
        screenResolutionHeight: (function screenResolutionHeight() {
          return (window.screen && window.screen.height) || -1
        })(),
        locationHref: window.location ? window.location.href : 'NOT_SUPPORTED',
        locationSearch: window.location
          ? window.location.search
          : 'NOT_SUPPORTED',
        locationOrigin: window.location
          ? window.location.origin
          : 'NOT_SUPPORTED',
        screenOrientation: (function screenOrientation() {
          return {
            angle:
              (window.screen &&
                window.screen.orientation &&
                window.screen.orientation.angle) ||
              0,
            type:
              (window.screen &&
                window.screen.orientation &&
                window.screen.orientation.type) ||
              'NOT_SUPPORTED',
          }
        })(),
        availableScreenResolutionWidth:
          (function availableScreenResolutionWidth() {
            return (window.screen && window.screen.availWidth) || -1
          })(),
        availableScreenResolutionHeight:
          (function availableScreenResolutionHeight() {
            return (window.screen && window.screen.availHeight) || -1
          })(),
        timezoneOffset: (function timezoneOffset() {
          return new Date().getTimezoneOffset() || 0
        })(),
        timeZone: (function timeZone() {
          return window.Intl && window.Intl.DateTimeFormat
            ? new window.Intl.DateTimeFormat().resolvedOptions().timeZone
            : ''
        })(),
        sessionStorageKey: (function sessionStorageKey() {
          try {
            return setResponse(window.sessionStorage)
          } catch (e) {
            return 'NOT_SUPPORTED'
          }
        })(),
        localStorageKey: (function localStorageKey() {
          try {
            return setResponse(window.localStorage)
          } catch (e) {
            return 'NOT_SUPPORTED'
          }
        })(),
        indexedDbKey: (function indexedDbKey() {
          try {
            return setResponse(window.indexedDB)
          } catch (e) {
            return 'NOT_SUPPORTED'
          }
        })(),
        addBehaviorKey: (function addBehaviorKey() {
          return setResponse(
            (document.body && document.body.addBehavior) || 'NOT_SUPPORTED',
          )
        })(),
        openDatabaseKey: (function openDatabaseKey() {
          return setResponse(window.openDatabase || 'NOT_SUPPORTED')
        })(),
        cpuClassKey: (function cpuClassKey() {
          return setResponse(navigator.cpuClass || 'NOT_SUPPORTED')
        })(),
        platformKey: (function platformKey() {
          return setResponse(navigator.platform || 'NOT_SUPPORTED')
        })(),
        doNotTrackKey: (function doNotTrackKey() {
          return setResponse(
            navigator.doNotTrack ||
              navigator.msDoNotTrack ||
              window.doNotTrack ||
              'NOT_SUPPORTED',
          )
        })(),
        isCanvasSupported: (function isCanvasSupported() {
          var e = document.createElement('canvas')
          return setResponse(
            (e.getContext && e.getContext('2d')) || 'NOT_SUPPORTED',
          )
        })(),
        adBlockKey: (function adBlockKey() {
          var e = document.createElement('div')
          ;(e.innerHTML = '&nbsp;'), (e.className = 'adsbox')
          var t = !1
          try {
            document.body.appendChild(e),
              (t =
                0 ===
                document.getElementsByClassName('adsbox')[0].offsetHeight),
              document.body.removeChild(e)
          } catch (e) {
            t = 'NOT_SUPPORTED'
          }
          return setResponse(t)
        })(),
        hasLiedLanguagesKey: (function hasLiedLanguagesKey() {
          try {
            return setResponse(
              !!navigator.languages &&
                navigator.languages[0].substr(0, 2) !==
                  navigator.language.substr(0, 2),
            )
          } catch (e) {
            return 'NOT_SUPPORTED'
          }
        })(),
        javaEnabled: (function javaEnabled() {
          return setResponse(navigator.javaEnabled() || !1)
        })(),
        deviceClockSpeed: (function deviceClockSpeed() {
          return (window.performance && window.performance.now()) || -1
        })(),
        loadEventStart: (function loadEventStart() {
          return window.performance
            ? window.performance.timing.loadEventStart
            : -1
        })(),
        loadEventEnd: (function loadEventEnd() {
          return window.performance
            ? window.performance.timing.loadEventEnd
            : -1
        })(),
        loadTime: (function loadTime() {
          return window.performance
            ? window.performance.timing.loadEventEnd -
                window.performance.timing.loadEventStart
            : -1
        })(),
        documentLoad: (function documentLoad() {
          return window.performance
            ? window.performance.timing.domContentLoadedEventEnd -
                window.performance.timing.navigationStart
            : -1
        })(),
      }
    }
  },
  function (e, t, n) {
    'use strict'
    e.exports = function () {
      var e = ['monospace', 'sans-serif', 'serif'],
        t = [
          'Abadi MT Condensed Light',
          'Adobe Fangsong Std',
          'Adobe Hebrew',
          'Adobe Ming Std',
          'Agency FB',
          'Aharoni',
          'Andalus',
          'Angsana New',
          'AngsanaUPC',
          'Aparajita',
          'Arab',
          'Arabic Transparent',
          'Arabic Typesetting',
          'Arial Baltic',
          'Arial Black',
          'Arial CE',
          'Arial CYR',
          'Arial Greek',
          'Arial TUR',
          'Arial',
          'Batang',
          'BatangChe',
          'Bauhaus 93',
          'Bell MT',
          'Bitstream Vera Serif',
          'Bodoni MT',
          'Bookman Old Style',
          'Braggadocio',
          'Broadway',
          'Browallia New',
          'BrowalliaUPC',
          'Calibri Light',
          'Calibri',
          'Californian FB',
          'Cambria Math',
          'Cambria',
          'Candara',
          'Castellar',
          'Casual',
          'Centaur',
          'Century Gothic',
          'Chalkduster',
          'Colonna MT',
          'Comic Sans MS',
          'Consolas',
          'Constantia',
          'Copperplate Gothic Light',
          'Corbel',
          'Cordia New',
          'CordiaUPC',
          'Courier New Baltic',
          'Courier New CE',
          'Courier New CYR',
          'Courier New Greek',
          'Courier New TUR',
          'Courier New',
          'DFKai-SB',
          'DaunPenh',
          'David',
          'DejaVu LGC Sans Mono',
          'Desdemona',
          'DilleniaUPC',
          'DokChampa',
          'Dotum',
          'DotumChe',
          'Ebrima',
          'Engravers MT',
          'Eras Bold ITC',
          'Estrangelo Edessa',
          'EucrosiaUPC',
          'Euphemia',
          'Eurostile',
          'FangSong',
          'Forte',
          'FrankRuehl',
          'Franklin Gothic Heavy',
          'Franklin Gothic Medium',
          'FreesiaUPC',
          'French Script MT',
          'Gabriola',
          'Gautami',
          'Georgia',
          'Gigi',
          'Gisha',
          'Goudy Old Style',
          'Gulim',
          'GulimChe',
          'GungSeo',
          'Gungsuh',
          'GungsuhChe',
          'Haettenschweiler',
          'Harrington',
          'Hei S',
          'HeiT',
          'Heisei Kaku Gothic',
          'Hiragino Sans GB',
          'Impact',
          'Informal Roman',
          'IrisUPC',
          'Iskoola Pota',
          'JasmineUPC',
          'KacstOne',
          'KaiTi',
          'Kalinga',
          'Kartika',
          'Khmer UI',
          'Kino MT',
          'KodchiangUPC',
          'Kokila',
          'Kozuka Gothic Pr6N',
          'Lao UI',
          'Latha',
          'Leelawadee',
          'Levenim MT',
          'LilyUPC',
          'Lohit Gujarati',
          'Loma',
          'Lucida Bright',
          'Lucida Console',
          'Lucida Fax',
          'Lucida Sans Unicode',
          'MS Gothic',
          'MS Mincho',
          'MS PGothic',
          'MS PMincho',
          'MS Reference Sans Serif',
          'MS UI Gothic',
          'MV Boli',
          'Magneto',
          'Malgun Gothic',
          'Mangal',
          'Marlett',
          'Matura MT Script Capitals',
          'Meiryo UI',
          'Meiryo',
          'Menlo',
          'Microsoft Himalaya',
          'Microsoft JhengHei',
          'Microsoft New Tai Lue',
          'Microsoft PhagsPa',
          'Microsoft Sans Serif',
          'Microsoft Tai Le',
          'Microsoft Uighur',
          'Microsoft YaHei',
          'Microsoft Yi Baiti',
          'MingLiU',
          'MingLiU-ExtB',
          'MingLiU_HKSCS',
          'MingLiU_HKSCS-ExtB',
          'Miriam Fixed',
          'Miriam',
          'Mongolian Baiti',
          'MoolBoran',
          'NSimSun',
          'Narkisim',
          'News Gothic MT',
          'Niagara Solid',
          'Nyala',
          'PMingLiU',
          'PMingLiU-ExtB',
          'Palace Script MT',
          'Palatino Linotype',
          'Papyrus',
          'Perpetua',
          'Plantagenet Cherokee',
          'Playbill',
          'Prelude Bold',
          'Prelude Condensed Bold',
          'Prelude Condensed Medium',
          'Prelude Medium',
          'PreludeCompressedWGL Black',
          'PreludeCompressedWGL Bold',
          'PreludeCompressedWGL Light',
          'PreludeCompressedWGL Medium',
          'PreludeCondensedWGL Black',
          'PreludeCondensedWGL Bold',
          'PreludeCondensedWGL Light',
          'PreludeCondensedWGL Medium',
          'PreludeWGL Black',
          'PreludeWGL Bold',
          'PreludeWGL Light',
          'PreludeWGL Medium',
          'Raavi',
          'Rachana',
          'Rockwell',
          'Rod',
          'Sakkal Majalla',
          'Sawasdee',
          'Script MT Bold',
          'Segoe Print',
          'Segoe Script',
          'Segoe UI Light',
          'Segoe UI Semibold',
          'Segoe UI Symbol',
          'Segoe UI',
          'Shonar Bangla',
          'Showcard Gothic',
          'Shruti',
          'SimHei',
          'SimSun',
          'SimSun-ExtB',
          'Simplified Arabic Fixed',
          'Simplified Arabic',
          'Snap ITC',
          'Sylfaen',
          'Symbol',
          'Tahoma',
          'Times New Roman Baltic',
          'Times New Roman CE',
          'Times New Roman CYR',
          'Times New Roman Greek',
          'Times New Roman TUR',
          'Times New Roman',
          'TlwgMono',
          'Traditional Arabic',
          'Trebuchet MS',
          'Tunga',
          'Tw Cen MT Condensed Extra Bold',
          'Ubuntu',
          'Umpush',
          'Univers',
          'Utopia',
          'Utsaah',
          'Vani',
          'Verdana',
          'Vijaya',
          'Vladimir Script',
          'Vrinda',
          'Webdings',
          'Wide Latin',
          'Wingdings',
          'Arial',
          'Arial Black',
          'Bookman Old Style',
          'Calibri',
          'Cambria',
          'Cambria Math',
          'Century Gothic',
          'Comic Sans MS',
          'Consolas',
          'Courier New',
          'Georgia',
          'Impact',
          'Lucida Bright',
          'Lucida Console',
          'Lucida Fax',
          'Lucida Sans Unicode',
          'Microsoft Sans Serif',
          'MS Gothic',
          'MS PGothic',
          'MS Reference Sans Serif',
          'Palatino Linotype',
          'Segoe Print',
          'Segoe Script',
          'Segoe UI',
          'Segoe UI Light',
          'Segoe UI Semibold',
          'Segoe UI Symbol',
          'Tahoma',
          'Times New Roman',
          'Trebuchet MS',
          'Verdana',
          'Wingdings',
        ],
        n = 'wwmmllii',
        o = document.getElementsByTagName('body')[0],
        i = document.createElement('div'),
        r = document.createElement('div'),
        a = { width: {}, height: {} }
      function createSpan() {
        var e = document.createElement('span')
        return (
          (e.style.cssText =
            'position: absolute; left: -9999px; font-size: 72px; font-style: normal; font-weight: normal; letter-spacing: normal; line-break: auto; line-height: normal; text-transform: none; text-align: left; text-decoration: none; text-shadow: none; white-space: normal; word-break: normal; word-spacing: normal;'),
          (e.innerHTML = n),
          e
        )
      }
      function createSpanWithFonts(e, t) {
        var n = createSpan()
        return (n.style.fontFamily = "'" + e + "'," + t), n
      }
      function isFontAvailable(t) {
        for (var n = !1, o = 0; o < e.length; o++)
          if (
            (n =
              t[o].offsetWidth !== a.width[e[o]] ||
              t[o].offsetHeight !== a.height[e[o]])
          )
            return n
        return n
      }
      try {
        var s = (function initializeBaseFontsSpans() {
          for (var t = [], n = 0, o = e.length; n < o; n++) {
            var r = createSpan()
            ;(r.style.fontFamily = e[n]), i.appendChild(r), t.push(r)
          }
          return t
        })()
        o.appendChild(i)
        for (var c = 0, u = e.length; c < u; c++)
          (a.width[e[c]] = s[c].offsetWidth),
            (a.height[e[c]] = s[c].offsetHeight)
        var l = (function initializeFontsSpans() {
          for (var n = {}, o = 0, i = t.length; o < i; o++) {
            for (var a = [], s = 0, c = e.length; s < c; s++) {
              var u = createSpanWithFonts(t[o], e[s])
              r.appendChild(u), a.push(u)
            }
            n[t[o]] = a
          }
          return n
        })()
        o.appendChild(r)
        for (var d = [], g = 0, w = t.length; g < w; g++)
          isFontAvailable(l[t[g]]) && d.push(t[g])
        return o.removeChild(r), o.removeChild(i), d
      } catch (e) {
        return window.AF_SDK.utils.logger('Font detector error: ' + e), []
      }
    }
  },
  function (e, t, n) {
    'use strict'
    e.exports = (function () {
      var e =
        '[object Storage]' ===
        Object.prototype.toString.call(window.localStorage)
      function missingKey(e) {
        e =
          arguments.length <= 0 || void 0 === arguments[0] ? null : arguments[0]
        return (
          window.AF_SDK.utils.logger(
            'Storage key is missing in localStorage',
            e,
          ),
          e || !0
        )
      }
      function missingLocalService() {
        return window.AF_SDK.utils.logger(
          'localStorage is not being supported by this browser',
        )
      }
      return {
        getItem: e
          ? function (e, t) {
              return (
                e || missingKey(t),
                (function returnVal(e) {
                  return '[object String]' ===
                    Object.prototype.toString.call(e) &&
                    window.AF_SDK.utils.isJson(e)
                    ? window.AF_SDK.utils.tcJSON(e, 'parse')
                    : e
                })(localStorage.getItem(e)) ||
                  (function returnDefVal(e, t) {
                    return (
                      window.AF_SDK.utils.logger(
                        'The provided key [' +
                          e +
                          '] returned no value from localStorage, using default value:',
                        t,
                      ),
                      t || null
                    )
                  })(e, t)
              )
            }
          : missingLocalService,
        setItem: e
          ? function (e, t) {
              e || missingKey(),
                localStorage.setItem(
                  e,
                  '[object Object]' === Object.prototype.toString.call(t)
                    ? window.AF_SDK.utils.tcJSON(t, 'stringify')
                    : t,
                )
            }
          : missingLocalService,
        removeItem: e
          ? function (e) {
              e || missingKey(), localStorage.removeItem(e)
            }
          : missingLocalService,
        clearAll: e
          ? function () {
              localStorage.clear()
            }
          : missingLocalService,
      }
    })()
  },
  function (e, t, n) {
    'use strict'
    e.exports = (function () {
      var e =
        '[object Storage]' ===
        Object.prototype.toString.call(window.sessionStorage)
      function missingKey(e) {
        e =
          arguments.length <= 0 || void 0 === arguments[0] ? null : arguments[0]
        return (
          window.AF_SDK.utils.logger(
            'Storage key is missing in sessionStorage',
            e,
          ),
          e || !0
        )
      }
      function missingLocalService() {
        return window.AF_SDK.utils.logger(
          'sessionStorage Storage is not being supported by this browser',
        )
      }
      return {
        getItem: e
          ? function (e, t) {
              return (
                e || missingKey(t),
                (function returnVal(e) {
                  return '[object String]' ===
                    Object.prototype.toString.call(e) &&
                    window.AF_SDK.utils.isJson(e)
                    ? window.AF_SDK.utils.tcJSON(e, 'parse')
                    : e
                })(sessionStorage.getItem(e)) ||
                  (function returnDefVal(e, t) {
                    return (
                      window.AF_SDK.utils.logger(
                        'The provided key [' +
                          e +
                          '] returned no value from sessionStorage, using default value:',
                        t,
                      ),
                      t || null
                    )
                  })(e, t)
              )
            }
          : missingLocalService,
        setItem: e
          ? function (e, t) {
              e || missingKey(),
                sessionStorage.setItem(
                  e,
                  '[object Object]' === Object.prototype.toString.call(t)
                    ? window.AF_SDK.utils.tcJSON(t, 'stringify')
                    : t,
                )
            }
          : missingLocalService,
        removeItem: e
          ? function (e) {
              e || missingKey(), sessionStorage.removeItem(e)
            }
          : missingLocalService,
        clearAll: e
          ? function () {
              sessionStorage.clear()
            }
          : missingLocalService,
      }
    })()
  },
  function (e, t, n) {
    'use strict'
    e.exports = (function () {
      function isDocument() {
        return 'undefined' == typeof document
      }
      function missingDocument() {
        window.AF_SDK.utils.logger('Document is missing in this browser')
      }
      function assign(e) {
        return Object.assign(
          { path: '/' },
          e,
          'number' == typeof e.expires
            ? { expires: new Date(1 * new Date() + 864e5 * e.expires) }
            : {},
          e.expires ? { expires: e.expires.toUTCString() } : {},
        )
      }
      function encodeKey(e) {
        return encodeURIComponent(String(e))
          .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
          .replace(/[\(\)]/g, escape)
      }
      function decode(e) {
        return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent)
      }
      function stringifyAttributes(e) {
        var t = ''
        for (var n in e) e[n] && (t += '; ' + n + '=' + e[n].split(';')[0])
        return t
      }
      function convertType(e, t) {
        return window.AF_SDK.utils.isJson(e)
          ? window.AF_SDK.utils.tcJSON(e, t)
          : e
      }
      return {
        get: isDocument()
          ? missingDocument
          : function (e) {
              return (function rescueCookie(e, t, n) {
                ;(t =
                  arguments.length <= 1 || void 0 === arguments[1]
                    ? null
                    : arguments[1]),
                  (n =
                    arguments.length <= 2 || !arguments[2] ? {} : arguments[2])
                for (var o = 0, i = e.length; o < i; o++)
                  try {
                    var r = e[o].split('='),
                      a = decode(r[0]),
                      s = convertType(decode(r[1]), 'parse')
                    if (a === t) return s
                    t || (n[a] = s)
                  } catch (e) {
                    continue
                  }
                return (
                  t &&
                    window.AF_SDK.utils.logger(
                      '[' + t + "] - Doesn't exist in stored cookies",
                      e,
                    ),
                  t ? null : n
                )
              })(document.cookie ? document.cookie.split('; ') : [], e)
            },
        set: isDocument()
          ? missingDocument
          : function (e, t, n) {
              var o = convertType(t, 'stringify')
              if (o)
                return (document.cookie =
                  encodeKey(e) +
                  '=' +
                  (function encodeVal(e) {
                    return encodeURIComponent(
                      String(
                        window.AF_SDK.utils.isJson(e)
                          ? window.AF_SDK.utils.tcJSON(e, 'stringify')
                          : e,
                      ),
                    ).replace(
                      /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                      decodeURIComponent,
                    )
                  })(o) +
                  stringifyAttributes(assign(n)))
            },
        remove: isDocument()
          ? missingDocument
          : function (e) {
              return (document.cookie =
                encodeKey(e) +
                '=' +
                stringifyAttributes(assign({ expires: -1 })))
            },
      }
    })()
  },
  function (e, t, n) {
    'use strict'
    e.exports = (function () {
      function withBody(e) {
        return -1 !== ['POST', 'PUT'].indexOf(e)
      }
      function ajax(e, t, n, o, i, r, a, s) {
        if (!t || !t.length)
          return window.AF_SDK.utils.logger(
            'Cannot perform ajax request, request is missing url',
            arguments,
          )
        var c = window.XMLHttpRequest
          ? new XMLHttpRequest()
          : new ActiveXObject('Microsoft.XMLHTTP')
        c.open(
          e,
          withBody(e)
            ? t
            : t +
                (function convertBodyToQuery(e) {
                  var t = '?'
                  for (var n in e)
                    Object.hasOwnProperty(n) && (t += n + '=' + e[n] + '&')
                  return t.slice(0, -1)
                })(o),
          !0,
        ),
          (c.timeout = i),
          (c.withCredentials = r),
          (function setHeaders(e, t, n) {
            Object.keys(
              Object.assign(
                t,
                withBody(n) ? { 'Content-type': 'text/plain' } : {},
              ),
            ).forEach(function (n) {
              e.setRequestHeader(n, t[n])
            })
          })(c, n, e),
          (c.onreadystatechange = function () {
            return 4 !== c.readyState
              ? { status: c.status, text: c.statusText }
              : c.status >= 200 && c.status < 400
              ? a &&
                a({
                  status: c.status,
                  data:
                    ((e = c.responseText),
                    '[object Object]' === Object.prototype.toString.call(e)
                      ? e
                      : window.AF_SDK.utils.tcJSON(e, 'parse')),
                  getHeaders: c.getAllResponseHeaders(),
                })
              : s && s({ status: c.status, text: c.statusText })
          }),
          withBody(e) ? c.send(JSON.stringify(o)) : c.send(),
          (c.ontimeout = function () {
            return window.AF_SDK.utils.logger(
              'Ajax request was failed because of timeout',
              Object.assign({}, arguments, {
                status: c.status,
                data: c.responseText,
              }),
            )
          }),
          (c.onerror = function () {
            return window.AF_SDK.utils.logger(
              'Ajax request was failed because of error',
              Object.assign({}, arguments, {
                status: c.status,
                data: c.responseText,
              }),
            )
          }),
          (c.onabort = function () {
            return window.AF_SDK.utils.logger(
              'Ajax request was failed because of abort action',
              Object.assign({}, arguments, {
                status: c.status,
                data: c.responseText,
              }),
            )
          })
      }
      return function () {
        var e = arguments[0] || {},
          t = e.hasOwnProperty('method') ? e.method : 'POST',
          n = e.hasOwnProperty('url') ? e.url : null,
          o = e.hasOwnProperty('headers') ? e.headers : {},
          i = e.hasOwnProperty('body') ? e.body : null,
          r = e.hasOwnProperty('timeout') ? e.timeout : 1e4,
          a = !e.hasOwnProperty('withCredentials') || e.withCredentials,
          s = e.hasOwnProperty('cb') ? e.cb : null,
          c = e.hasOwnProperty('fail') ? e.fail : null
        return s || c || !navigator.sendBeacon
          ? ajax(t, n, o, i, r, a, s, c)
          : (function beacon(e, t) {
              return navigator.sendBeacon(e, JSON.stringify(t))
            })(n, i)
      }
    })()
  },
]

export function init() {
  script(e)
}
